import { api } from '@/utils/api'

import { ApiResponseHandler, Postable } from './ApiInterfaces'
import { ApiBase } from './ApiBase'

export namespace ApiTaCa030 {
  // POST parameters
  export namespace Post {
    // API Request
    export interface Request {
      body: {
        memberScheduleId: number
        lessonDate: string
      }
    }

    // API Response
    export interface Response {}
  }

  // API Path
  const path: string = '/ta/calendarChangeInfo'

  // API本体
  export class Api extends ApiBase implements Postable<Post.Request, Post.Response, undefined> {
    // POST
    public post<R>(
      params: Post.Request,
      successHandler: ApiResponseHandler<Post.Response, R>,
      errorHandler: ApiResponseHandler<undefined, R>
    ): Promise<R | null> {
      // API呼び出し
      return this.callbackWrapper<Post.Response, undefined, R>(
        api.post<Post.Response>(path, params.body),
        successHandler,
        errorHandler,
        undefined,
        undefined
      )
    }
  }
}
